import { documentationActions } from '../../actions/constant';

const {
    RESET_SAVE_MISCELLANEOUS_DOCUMENTS,
    FAILURE_SAVE_MISCELLANEOUS_DOCUMENTS,
    SUCCESS_SAVE_MISCELLANEOUS_DOCUMENTS,
    LOADING_SAVE_MISCELLANEOUS_DOCUMENTS
} = documentationActions;

const intitialstate: object = {
  response: null,
  isDocumentSave: false,
  loading: false,
};

export const saveMiscellaneousDocumentsReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_SAVE_MISCELLANEOUS_DOCUMENTS: {
      return {
        ...state,
        isDocumentSave: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_SAVE_MISCELLANEOUS_DOCUMENTS:
      return {
        ...state,
        isDocumentSave: false,
        response: action.payload,
        loading: true,
      };

    case LOADING_SAVE_MISCELLANEOUS_DOCUMENTS:
      return {
        ...state,
        loading: true,
      };

    case RESET_SAVE_MISCELLANEOUS_DOCUMENTS:
        return intitialstate;

    default:
      return state;
  }
};
